export function isAbsolutePath(path) {
  return /^(https?|tel|mailto|map)/.test(path)
}

export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}



// WEBPACK FOOTER //
// ./src/utils/validate.js